<!-- 推送临时商品 -->
<template>
    <div id="push">
        <div class="push-title">
            在线企业列表
        </div>
        <div>
            <div class="customer-item" @click="push(item)" v-for="item in tableData" v-show="item.uType == 1">
                {{item.uName}}
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: '',
        props:{
            goodMsg:Object,
        },
        components: {

        },
        data(){
            return {
                tableData:[],
                tableDataLength:[]
            }
        },
        mounted(){
            this.getTableData()
        },
        methods:{
            // 推送商品
            push(item){
                let pushMsg = {
                    customerMsg:item,
                    goodMsg:this.goodMsg
                }
                this.$store.commit('updatePushGoodMsg',pushMsg)
                this.$message({
                    message: '商品已推送',
                    type: 'success'
                });
                this.$emit('closeDialog')
            },
            // 加载顾客列表
            getTableData(){
                let _tableData = this.$store.state.chatingList
                // 不推给车主
                for (let i = 0;i<_tableData.length;i++){
                    if (_tableData[i].joinReferer != 0 || _tableData[i].UType != 0){
                        this.tableData.push(_tableData[i])
                    }
                }
            },
        }
    }
</script>
<style lang="less" scoped>
    .push-title{
        font-size: @font-sm;
        font-weight: bold;
        margin-bottom: 20px;
        padding-left: 10px;
    }
    .customer-item {
        cursor: pointer;
        padding: 10px;
        border-bottom: 1px solid @border4Color;
        &:hover {
            background: @border4Color;
        }
    }
</style>
